import React from 'react';
import './i18n';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ChakraProvider } from '@chakra-ui/react';
import { system } from './Theme';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <React.StrictMode>
        <ChakraProvider value={system}>
            <BrowserRouter>
                <Toaster />
                <App />
            </BrowserRouter>
        </ChakraProvider>
    </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
